// Without this dynamic parameter AOT compiling will fail.
// @see https://angular.io/guide/angular-compiler-options#strictmetadataemit
// @dynamic
export class SelfExamAnswerResponse {
  public id!: string;

  public answer!: string;

  public submittedAnswerAsCorrect!: boolean;

  public static fromDto(dto: any): SelfExamAnswerResponse {
    const response: SelfExamAnswerResponse = new SelfExamAnswerResponse();
    response.id = dto.id;
    response.answer = dto.answer;
    response.submittedAnswerAsCorrect = dto.submittedAnswerAsCorrect;
    return response;
  }
}
